let agentDetailTabsMainFunctions = (function () {
  let modules = {};

  modules.likeUnlikeAgent = function (button, agentId, isUnLike = true) {
    let url = isUnLike
        ? Routes.destroy_favorite_agents_path()
        : Routes.create_favorite_agents_path();
    let submitAjax = $.ajax({
      url: url,
      method: "POST",
      data: {
        authenticity_token: $("meta[name=csrf-token]").prop("content"),
        agent_id: agentId,
      },
    });
    submitAjax.done(function (response) {
      if (response.save) {
        modules.syncLikeStatus(agentId, isUnLike);
      } else {
        commonFunctions.notifyToastr(button, commonFunctions.TOASTR_ERROR);
      }
      commonFunctions.enableButtonWhenLoadingDone(button)
    });
    submitAjax.fail(function (response) {
      commonFunctions.notifyToastr(button, commonFunctions.TOASTR_ERROR);
      modules.syncLikeStatus(agentId, !isUnLike);
      commonFunctions.enableButtonWhenLoadingDone(button)
    });
  };

  modules.syncLikeStatus = function (job_id, isUnLike = true) {
    let textButton = $(".js-btn-favorite-agent .text-button");
    if (isUnLike) {
      textButton.text(textButton.data('text-favorite'))
      $(".js-btn-favorite-agent").removeClass('liked')
    } else {
      textButton.text(textButton.data('text-un-favorite'))
      $(".js-btn-favorite-agent").addClass('liked')
    }
  };

  return modules;
})(window.jQuery, window, document);

$(document).ready(function () {
  $(".js-btn-favorite-agent").on("click", function () {
    commonFunctions.disabledButtonWhenLoading($(this))
    agentDetailTabsMainFunctions.likeUnlikeAgent($(this), $(this).data("agent_id"), $(this).hasClass('liked'))
  })  
})
